import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-401518b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))


import { defineComponent, defineProps, onMounted } from 'vue'
import {
  ArrowUpBold,
  ArrowDownBold
} from '@element-plus/icons-vue'
import { TableItemEvents } from '../utils'

const __default__ = defineComponent({
  name: 'TableItemEventEditor'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  itemEvents: {
    type: Object as () => TableItemEvents,
    require: true
  }
},
  setup(__props) {


const props = __props

// 添加事件
function addItemEvent () {
  // eslint-disable-next-line
  if (props.itemEvents!.eventList.length >= 1) {
    // eslint-disable-next-line
    const i = props.itemEvents!.eventList.length - 1
    // eslint-disable-next-line
    props.itemEvents!.eventList[i].isNewEvent = false
  }
  // eslint-disable-next-line
  props.itemEvents!.eventList.push({
    label: '',
    targetUrl: '',
    isShowEditDlg: false,
    isConfirm: true,
    fieldName: '',
    fieldValue: '',
    isNewEvent: true,
    isExpand: false
  })
}
// 删除事件
function deleteItemEvent (index: number) {
  // eslint-disable-next-line
  props.itemEvents!.eventList.splice(index, 1)
}
function expandItem (index: number) {
  // eslint-disable-next-line
  props.itemEvents!.eventList[index].isExpand = !props.itemEvents!.eventList[index].isExpand
  // eslint-disable-next-line
  console.log('isExpand=' + props.itemEvents!.eventList[props.itemEvents!.eventList.length - 1].isExpand)
}
onMounted(async () => {
  // eslint-disable-next-line
  if (props.itemEvents!.eventList.length === 0) {
    addItemEvent()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.itemEvents.eventList, (event, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
      _createVNode(_component_el_divider, { style: {"margin":"0px"} }),
      (event.isExpand)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_col, { class: "attr-label" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { class: "attr-row" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_text, { type: "info" }, {
                      default: _withCtx(() => [
                        _createTextVNode("按钮标题:")
                      ]),
                      _: 1
                    }),
                    _hoisted_1,
                    _createVNode(_component_el_button, {
                      type: "info",
                      icon: _unref(ArrowUpBold),
                      onClick: ($event: any) => (expandItem(index)),
                      style: {"height":"24px !important"},
                      plain: ""
                    }, null, 8, ["icon", "onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: event.label,
                  "onUpdate:modelValue": ($event: any) => ((event.label) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { class: "attr-label" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("服务器接口:")
                  ]),
                  _: 1
                }),
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: event.targetUrl,
                  "onUpdate:modelValue": ($event: any) => ((event.targetUrl) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { class: "attr-label" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("是否需要确认窗口:")
                  ]),
                  _: 1
                }),
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: event.isConfirm,
                  "onUpdate:modelValue": ($event: any) => ((event.isConfirm) = $event),
                  style: {"--el-switch-on-color":"#2196F3","--el-switch-off-color":"#B0B0B0"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { class: "attr-label" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("显示编辑窗口:")
                  ]),
                  _: 1
                }),
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: event.isShowEditDlg,
                  "onUpdate:modelValue": ($event: any) => ((event.isShowEditDlg) = $event),
                  style: {"--el-switch-on-color":"#2196F3","--el-switch-off-color":"#B0B0B0"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { class: "attr-label" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑窗口标题:")
                  ]),
                  _: 1
                }),
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: event.editDlgTitle,
                  "onUpdate:modelValue": ($event: any) => ((event.editDlgTitle) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { class: "attr-label" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑窗口【确定】按钮名称:")
                  ]),
                  _: 1
                }),
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: event.editOkBtnName,
                  "onUpdate:modelValue": ($event: any) => ((event.editOkBtnName) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { class: "attr-label" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("关联字段:")
                  ]),
                  _: 1
                }),
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: event.fieldName,
                  "onUpdate:modelValue": ($event: any) => ((event.fieldName) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { class: "attr-label" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("字段值条件:")
                  ]),
                  _: 1
                }),
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: event.fieldValue,
                  "onUpdate:modelValue": ($event: any) => ((event.fieldValue) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  type: "flex",
                  class: "mb-2",
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    (event.isNewEvent)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          class: "full-width-button",
                          style: {"flex-grow":"1"},
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (addItemEvent()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("添加事件")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          class: "full-width-button",
                          style: {"flex-grow":"1"},
                          onClick: ($event: any) => (deleteItemEvent(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除事件")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ], 64))
        : (_openBlock(), _createBlock(_component_el_col, {
            key: 1,
            class: "attr-label"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { class: "attr-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { type: "info" }, {
                    default: _withCtx(() => [
                      _createTextVNode("事件:" + _toDisplayString(event.isNewEvent?'添加新事件':event.label), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _hoisted_9,
                  _createVNode(_component_el_button, {
                    type: "info",
                    icon: _unref(ArrowDownBold),
                    onClick: ($event: any) => (expandItem(index)),
                    style: {"height":"24px !important"},
                    plain: ""
                  }, null, 8, ["icon", "onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
    ], 64))
  }), 128))
}
}

})